<template>
  <label class="has-street-checkbox">
    <input
      type="checkbox"
      :checked="props.modelValue"
      @change="emits('update:modelValue', ($event.target as HTMLInputElement).checked)"
    >
    丁目まで分割可能なエリアに限定
  </label>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{ modelValue?: boolean }>(), { modelValue: false })

const emits = defineEmits(['update:modelValue'])
</script>

<style scoped>
.has-street-checkbox {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 1px 1px 0px #00000029;
  border-radius: 4px;
  font: normal normal normal 13px/13px Noto Sans JP;
  color: #222222;
  cursor: pointer;
}
</style>
